module.exports = __webpack_public_path__ + "img/bg-5.fd68828f.jpg";